import { useEffect, useState } from 'react'
import {useCart} from './useCart'
import axios from 'axios'
import getMatchingVariants from '../components/portals/QuickAdd/getMatchingVariants'
import { OptionList, Product, ProductVariant } from '../util/typings'

export const useQuickAdd = () : Record<string,any> => {

  const [loading, setLoading] = useState(null as null|string)
  const [handle, setHandle] = useState(null as null|string)
  const [product, setProduct] = useState(null as null|Product)
  const [stockMap, setStockMap] = useState<Record<string, string>>()
  const [swatch, setSwatch] = useState<Record<string, string>>()
  const [selectedOptions, setSelectedOptions] = useState([null, null, null] as OptionList)
  const [currentVariant, setCurrentVariant] = useState(null as null|ProductVariant)
  const { addToCart } = useCart();

  const setDOMHelpers = () => {
    window['blubolt'].quickadd = {
      open: (handle, settings) => {
        setLoading(handle)
        let stockMap = {}
        let swatch = {}
        try {
          stockMap = settings && settings.stockMap ? JSON.parse(settings.stockMap) : {};
          swatch = settings && settings.swatch ? settings.swatch : {}
        } catch (e) {
          console.info(e)
        }
        setStockMap(stockMap)
        setSwatch(swatch)
        setHandle(handle)
      }
    }
  }

  useEffect(() => {
    setDOMHelpers()
  }, [])

  useEffect(() => {
    if (loading) {
      const button = document.querySelector(`[data-quick-add-btn="${loading}"]`)
      button.classList.add('loading')
    } else {
      const buttons = document.querySelectorAll('[data-quick-add-btn]')
      buttons.forEach(btn => btn.classList.remove('loading'))
    }
  }, [loading])

  useEffect(() => {
    if (handle) {
      axios.get(`/products/${handle}.js`).then(({ data }) => {
        const product = (data as Product)
        if (product.variants.length === 1) {
          addToCart(
            [{
              id: product.variants[0].id,
              quantity: 1
            }],
            true,
            () => {
              setHandle(null)
              setLoading(null)
            }
          )
        } else {
          setProduct(product)
          setLoading(null)
        }
      })

    } else {
      setProduct(null)
      setSelectedOptions([null, null, null])
      setLoading(null)
    }
  }, [handle])

  useEffect(() => {
    if (!product) {
      setCurrentVariant(null)
      return
    }

    const matchingVariants = getMatchingVariants(selectedOptions, product.variants);
    const selectedLength = selectedOptions.reduce((acca, option) => option === null ? acca : acca + 1, 0)
    if (selectedLength === product.options.length && matchingVariants.length === 1) {
      setCurrentVariant(matchingVariants[0])
    } else {
      setCurrentVariant(product.variants[0])
    }
  }, [
    selectedOptions,
    product
  ])

  useEffect(() => {
    if (currentVariant) {
      setSelectedOptions(currentVariant.options)
    }
  }, [currentVariant])

  return {
    product,
    stockMap,
    currentVariant,
    setHandle,
    selectedOptions,
    setSelectedOptions,
    swatch
  }
}

